import { 
    GET_DEVICE_DATA, GET_DEVICE_DATA_FAILED, 
    UPDATE_HEADER_INFO, UPDATE_HEADER_INFO_FAILED,
    UPDATE_FOOTER_INFO, UPDATE_FOOTER_INFO_FAILED,
    GET_CORE_LIST, GET_CORE_LIST_FAILED,
    GET_CORE_VIDEO_LIST, GET_CORE_VIDEO_LIST_FAILED,
    GET_COURSES_LIST, GET_COURSES_LIST_FAILED,
    GET_BOOKMARK_LIST, GET_BOOKMARK_LIST_FAILED,
    GET_UPDATESERIES_LIST, GET_UPDATESERIES_LIST_FAILED,
    GET_GUIDELINES_LIST, GET_GUIDELINES_LIST_FAILED,
    GET_PODCASTS_LIST, GET_PODCASTS_LIST_FAILED,
    HOME_UPDATES, HOME_UPDATES_FAILED,
    GET_CORE_SECTION, GET_CORE_SECTION_FAILED, 
    GET_TRANSCRIPTS, GET_TRANSCRIPTS_FAILED
} from "../actions";

import { 
    TEMP_NULL, TEMP_FEATURED, TEMP_EMPTY_ARRAY,
    TEMP_HOME_LIST, BACKGROUND_COLOR_MAIN 
} from "../common";

const INITIAL_STATE = {
    device: null,
    app: null,
    footerOne: 'home',
    footerTwo: 'settings',
    footerThree: 'profile',
    headerText: null,
    iconOne: null,
    iconTwo: null,
    backgroundcolor: BACKGROUND_COLOR_MAIN,
    homeList: TEMP_HOME_LIST,
    homeFeatured: TEMP_EMPTY_ARRAY,
    core: null,
    coresection: {},
    coresectionmenu: [],
    coresectionreferences:[],
    coresectionpresentations:[],
    corevideos: [],
    courses: [],
    transcripts: [],
    bookmarks: [],
    podcasts: [],
    guidelines: [],
    updateseries: [],
    pagecount: 8
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case HOME_UPDATES: 
            return { ...state, homeFeatured: action.payload }
        case GET_PODCASTS_LIST: 
            return { ...state, podcasts: action.payload }
        case GET_UPDATESERIES_LIST: 
            return { ...state, updateseries: action.payload }
        case GET_GUIDELINES_LIST: 
            return { ...state, guidelines: action.payload }
        case GET_BOOKMARK_LIST: 
            return { ...state, bookmarks: action.payload }
        case GET_COURSES_LIST: 
            return { ...state, courses: action.payload }
        case GET_CORE_LIST: 
            return { ...state, core: action.payload }
        case GET_CORE_SECTION: 
            return { 
                ...state, 
                coresection: action.payload,
                coresectionmenu: action.payload.menu,
                coresectionreferences: action.payload.references,
                coresectionpresentations: action.payload.presentations
            }
        case GET_CORE_VIDEO_LIST: 
            return { ...state, corevideos: action.payload }
        case GET_DEVICE_DATA: 
            return { ...state, device: action.payload }
        case GET_TRANSCRIPTS: 
            return { ...state, transcripts: action.payload }

        case UPDATE_HEADER_INFO: 
            return {
                ...state,
                iconOne: action.payload.iconOne,
                iconTwo: action.payload.iconTwo,
                headerText: action.payload.headerText,
                backgroundcolor: action.payload.backgroundcolor
            }

        case UPDATE_FOOTER_INFO: 
            return {
                ...state,
                footOne: action.payload.iconOne,
                footTwo: action.payload.iconTwo,
                footThree: action.payload.iconThree,
            }
    
        case GET_GUIDELINES_LIST_FAILED:
        case GET_UPDATESERIES_LIST_FAILED:
        case GET_DEVICE_DATA_FAILED:
        case GET_CORE_LIST_FAILED:
        case GET_CORE_VIDEO_LIST_FAILED:
        case GET_COURSES_LIST_FAILED:
        case UPDATE_HEADER_INFO_FAILED: 
        case GET_BOOKMARK_LIST_FAILED:
        case GET_PODCASTS_LIST_FAILED:
        case HOME_UPDATES_FAILED:
        case UPDATE_FOOTER_INFO_FAILED:
        case GET_CORE_SECTION_FAILED:
        case GET_TRANSCRIPTS_FAILED:
            return { ...state, error: action.payload }
        
        default: 
            return state
    }
}